import { Col, GRID } from '../../components/custom';

export default function DCS()
{
    return (
        <Col id='DCS' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Understanding Key Drivers of Customer Satisfaction</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To determine which customer experience dimensions have the greatest impact on overall customer satisfaction scores.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Approach: Multiple Linear Regression</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Dependent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Customer Satisfaction Score</strong> (1-5 scale)</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Independent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Product Quality</strong></li> 
                            <li className='descsmall'><strong>Customer Service</strong></li>
                            <li className='descsmall'><strong>Ease of Use</strong></li>
                            <li className='descsmall'><strong>Price Sensitivity</strong></li>
                        </ul>
                        <span className='descsmall'>Each independent variable was measured on a 1-5 Likert scale, where 1 indicates very dissatisfied/poor and 5 indicates very satisfied/excellent.</span>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <GRID className='_4x5'>
                            <span className='descsmall bold'>Driver</span>
                            <span className='descsmall bold'>Std. Coefficient</span>
                            <span className='descsmall bold'>P-value</span>
                            <span className='descsmall bold'>Interpretation</span>
                            <span className='descsmall bold left'>Product Quality</span>
                            <span className='descsmall'>0.725</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Strongest predictor — customers are significantly more satisfied with high-quality products.</span>
                            <span className='descsmall bold left'>Customer Service</span>
                            <span className='descsmall'>0.612</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Strong and significant — responsive and helpful customer service contributes greatly to satisfaction.</span>
                            <span className='descsmall bold left'>Ease of Use</span>
                            <span className='descsmall'>0.457</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Moderate impact — ease of using the product improves overall satisfaction.</span>
                            <span className='descsmall bold left'>Price Sensitivity</span>
                            <span className='descsmall'>0.320</span>
                            <span className='descsmall'>0.005</span>
                            <span className='descsmall left'>Significant, but lower impact — customers are sensitive to price changes, but it's less important than other factors.</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Insightful Takeaway:</span>
                        <span className='descsmall'><strong>Product quality</strong> emerged as the top driver of customer satisfaction, followed closely by <strong>customer service</strong>. This suggests that customers prioritize the quality of the product and the responsiveness of customer service when forming their satisfaction levels. <strong>Ease of use and price sensitivity</strong> also play important roles, though their impact is comparatively lower. Businesses should focus on enhancing product quality and customer support to drive higher customer satisfaction, while balancing price competitiveness.</span>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}